<mat-drawer-container autosize style="height: 100%">
  <mat-drawer #drawer mode="over" position="end" style="background: white;width: 100%">

    <app-create-site-message-drawer (onCloseClicked)="drawer.close()"
                                    [currentMessages]="currentMessages()"></app-create-site-message-drawer>

  </mat-drawer>

  <!--  <button (click)="_filter('halmstad')">find</button>-->
  <div style="background: var(--background);height: 100vh;padding: 0 40px">

    @if (currentMessages()?.length == 0) {
      <div style="display: grid;justify-items: center;align-content:center;height: 100vh">
        <svg width="101" height="101" viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M60.8108 80.0232V80.6544H61.4421H70.4599C70.7732 80.6544 70.9826 80.7534 71.1102 80.8771C71.2361 80.999 71.3316 81.1924 71.3316 81.4799V84.3934C71.3316 84.6809 71.2361 84.8743 71.1102 84.9962C70.9826 85.1199 70.7732 85.2188 70.4599 85.2188H61.4421H19.3587H10.3409C10.0276 85.2188 9.81813 85.1199 9.69054 84.9962C9.56472 84.8743 9.46914 84.6809 9.46914 84.3934V81.4799C9.46914 81.1924 9.56472 80.999 9.69054 80.8771C9.81813 80.7534 10.0276 80.6544 10.3409 80.6544H19.3587H19.99V80.0232V33.4078V27.5809V18.2578C19.99 14.2547 23.5964 10.7313 27.7754 10.7313H53.0254C57.2044 10.7313 60.8108 14.2547 60.8108 18.2578V27.5809V33.4078V80.0232ZM51.3606 40.8209L51.1769 40.6429H50.9212H50.8991C50.6144 40.6429 50.277 40.6428 49.9704 40.6853C49.6655 40.7275 49.2754 40.8249 48.9789 41.1122L41.6028 48.2614L38.7356 45.4824C38.2482 45.0101 37.702 45.0115 37.1786 45.0129C37.1503 45.013 37.122 45.0131 37.0938 45.0131C36.3831 45.0131 35.6414 45.3754 35.5669 46.105L29.3198 64.5579C29.0368 64.9459 29.1051 65.4284 29.3053 65.7517C29.4931 66.0551 29.813 66.2789 30.2008 66.3525C30.2157 66.366 30.2302 66.379 30.2443 66.3913C30.3082 66.4472 30.3948 66.5163 30.5061 66.5702C30.7188 66.6733 30.9374 66.6712 31.0523 66.67C31.0631 66.6699 31.073 66.6698 31.0819 66.6698L31.1038 66.6698C31.4142 66.6701 31.9381 66.6706 32.4231 66.2005L39.7992 59.0513L42.6664 61.8303C43.1514 62.3004 43.6753 62.2999 43.9857 62.2996L44.0075 62.2996H44.3081C45.0189 62.2996 45.7606 61.9373 45.835 61.2077L52.1203 42.6419L52.1537 42.5435V42.4395C52.1537 42.1359 52.018 41.8047 51.8955 41.5674C51.7622 41.309 51.5745 41.0282 51.3606 40.8209ZM55.4302 28.2121H56.0614V27.5809V18.2578C56.0614 17.4627 55.6581 16.7256 55.118 16.2021C54.5766 15.6774 53.825 15.2958 53.0254 15.2958H27.7754C26.9758 15.2958 26.2242 15.6774 25.6828 16.2021C25.1426 16.7256 24.7394 17.4627 24.7394 18.2578V27.5809V28.2121H25.3706H55.4302Z"
            stroke="#0C8A3C" stroke-width="1.2625"/>
          <path
            d="M71.9627 49.2375C60.8123 49.2375 51.7627 58.2871 51.7627 69.4375C51.7627 80.5879 60.8123 89.6375 71.9627 89.6375C83.1131 89.6375 92.1627 80.5879 92.1627 69.4375C92.1627 58.2871 83.1131 49.2375 71.9627 49.2375ZM82.1839 64.5289L70.0841 76.6287C69.7609 76.9519 69.3569 77.0933 68.9327 77.0933C68.5085 77.0933 68.1045 76.9317 67.7813 76.6287L61.7415 70.5889C61.1153 69.9627 61.1153 68.9325 61.7415 68.2861C62.3677 67.6599 63.3979 67.6599 64.0443 68.2861L68.9327 73.1745L79.8811 62.2261C80.5073 61.5797 81.5375 61.5797 82.1637 62.2261C82.7899 62.8523 82.7899 63.8825 82.1637 64.5289H82.1839Z"
            fill="#0C8A3C"/>
        </svg>

        <div data-testid="noMessageTitle" class="title-large" style="margin-top: 40px">Everything is prima!</div>
        <div data-testid="noMessage" class="body-large" style="margin-top: 16px">At the moment everything working,
          smille
          and be happy.
        </div>
        <button class="primary-button" style="margin-top: 40px;width: 300px"
                (click)="openCreateSiteMessageDialog(drawer)">
          Create message
        </button>
        <button class="secondary-button" style="margin-top: 16px; width: 300px"
                (click)="openCreateSiteMessageDialog(drawer)">
          History
        </button>

      </div>
    } @else {


      <div class="title-large" style="margin-bottom: 20px;padding-top: 40px">Current messages</div>

      <div style="display: grid;overflow-wrap: anywhere;
  grid-template-columns: repeat(3, 1fr); /* 3 columns with equal width */
  gap: 16px;">

        @for (siteMessage of currentMessages(); track siteMessage.id) {
          <div data-testid="dataCard" class="card" style="cursor: pointer" matRipple
               (click)="onSiteClicked(siteMessage)">
            <div class="card-body">

              <div style="display: flex;flex-direction: column;gap: 4px">
                <div data-testid="siteMessageId" class="body-large">{{ siteMessage.id }}</div>
                <div data-testid="siteName" class="title-medium">{{ siteMessage.siteName }}</div>
                <div data-testid="siteAddress" class="body-large">{{ siteMessage.address }}</div>
                <div data-testid="dateAdded"
                     class="body-large">{{ siteMessage.dateAdded?.toDate()|date:"dd MMM yyy HH:mm" }}
                </div>
                <div data-testid="addedBy" class="body-large">{{ siteMessage.addedBy }}</div>

              </div>
              <div class="divider-h" style="margin: 20px 0"></div>

              <div style="display: flex;flex-direction: column;gap: 4px">

                <div data-testid="siteTitle" class="title-small">{{ siteMessage.title }}</div>
                <div data-testid="siteMessage" class="body-large">{{ siteMessage.message }}</div>
              </div>

            </div>
          </div>
        }
      </div>
    }

  </div>


  <div class="fab-container" style="justify-content: center">
    <button (click)="openCreateSiteMessageDialog(drawer)" class="primary-button">Create site message</button>
  </div>

</mat-drawer-container>

